import agreement from './modules/agreement';
import appDownload from './modules/app-download';
import safety from './modules/safety';
import spec from './modules/spec';
import start from './modules/start';
import accountSafety from './modules/account-safety';
import question from './modules/question';
import compensation from './modules/overtime-compensation';
import setting from './modules/setting';
import TestIn from './modules/test-in';
import Wallet from './modules/wallet';
import VehicleRule from './modules/vehicle-rules';
import Enterprise from './modules/enterprise';
import DrivingBehaviorFeedback from './modules/driving-behavior-feedback';
const routes = [
  ...agreement,
  ...appDownload,
  ...safety,
  ...spec,
  ...start,
  ...accountSafety,
  ...question,
  ...compensation,
  ...setting,
  ...TestIn,
  ...VehicleRule,
  ...Enterprise,
  ...Wallet,
  ...DrivingBehaviorFeedback,
];

export default routes;
